import { StyleStateEnum } from '../../PageBuilder/enums/style-state.enum';

export enum DistributionStyleState {
    // Press Release
    DISTRIBUTION_1 = 'DISTRIBUTION_1',
    DISTRIBUTION_2 = 'DISTRIBUTION_2',
    // Minimalist
    DISTRIBUTION_3 = 'DISTRIBUTION_3',
    // Marketing
    DISTRIBUTION_4 = 'DISTRIBUTION_4',
    DISTRIBUTION_5 = 'DISTRIBUTION_5',
    CUSTOM = 'CUSTOM'
}

export type DistributionStyleStateEnum = StyleStateEnum | DistributionStyleState;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const DistributionStyleStateEnum = {
    ...StyleStateEnum,
    ...DistributionStyleState
};
